import { PRECIO_MAX_ARS } from '../../../core/catalog/precioLimites.js';

/** Texto para búsqueda insensible a mayúsculas y acentos. */
export function normalizarTextoBusquedaCatalogo(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

/** Entero 0..tope para filtros de precio; vacío → null */
export function parsePrecioFiltroEnteroCatalogo(raw, precioMaxCap = PRECIO_MAX_ARS) {
  const t = String(raw ?? '')
    .replace(/\D/g, '')
    .trim();
  if (t === '') return null;
  const n = parseInt(t, 10);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.min(n, precioMaxCap);
}

/** Si min > max, intercambia (misma semántica que el catálogo en UI). */
export function ordenarMinMaxFiltroPrecio(min, max) {
  if (min !== null && max !== null && min > max) return { min: max, max: min };
  return { min, max };
}

/**
 * @param {object[]} items
 * @param {{ q: string, cat: string, estado: string, min: number|null, max: number|null }} criterios
 */
export function filtrarProductosCatalogo(items, { q, cat, estado, min, max }) {
  return items.filter((it) => {
    const titulo = normalizarTextoBusquedaCatalogo(it.titulo);
    const descripcion = normalizarTextoBusquedaCatalogo(it.descripcion);
    const precio = Math.round(Number(it.precio ?? 0));
    const precioOk = Number.isFinite(precio) ? precio : 0;
    const okText = !q || titulo.includes(q) || descripcion.includes(q);
    const okCat = !cat || (it.categoria_id || 'general') === cat;
    const okEstado = !estado || (it.estado_producto || 'usado') === estado;
    const okMin = min === null || precioOk >= min;
    const okMax = max === null || precioOk <= max;
    return okText && okCat && okEstado && okMin && okMax;
  });
}

/**
 * ¿Hay búsqueda, categoría, estado avanzado o rango de precio aplicado?
 */
export function hayFiltrosCatalogoActivos({
  textoBusqueda,
  categoriaId,
  estadoProducto,
  precioMinRaw,
  precioMaxRaw,
  precioMaxCap = PRECIO_MAX_ARS,
}) {
  const q = normalizarTextoBusquedaCatalogo(textoBusqueda);
  const cat = String(categoriaId || '').trim();
  const adv = String(estadoProducto || '').trim();
  const minA = parsePrecioFiltroEnteroCatalogo(precioMinRaw, precioMaxCap);
  const maxA = parsePrecioFiltroEnteroCatalogo(precioMaxRaw, precioMaxCap);
  return Boolean(q || cat || adv || minA != null || maxA != null);
}
